<template>
    <div class="is-flex" style="justify-content: space-between">
        <button class="button is-dark" v-on:click="selectCompany()">
            <span class="icon">
                <i class="material-icons is-size-5 has-text-white">domain</i>
            </span>
        </button>
    </div>
</template>
<script>
import apiServices from "@/services/yungol-services";

export default {
    data(){
        return {
            params: this.$parent.params,
        }
    },
    methods:{
        async selectCompany() {
            try {
                const change = await apiServices.get(`/changecompany/${this.params.value}`);
                const empresa = await apiServices.get(`/empresacredential`);
                if (change.data && empresa.data) {
                    this.$store.commit("refreshEmpresa", empresa.data);
                    // REVISAR.... Y PASAR FUNCION AL BTN
                    await this.$swal({
                        title: this.params.data.nombre,
                        text: 'Se seleccionó correctamente la empresa.',
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 1700
                    })
                    this.$emit('rowPinning');
                }
            } catch (error) {
                console.log(error);
                await this.$swal({
                    title: this.params.data.nombre,
                    text: 'Error al cambiar de empresa.',
                    icon: 'error',
                    showConfirmButton: false,
                    timer: 1700
                })
            }
        },
    }
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/empresas/components/CellSelectCompany.vue